<template>
  <div class="select-box-size">
    <a-radio-group class="box-size-radio-group" :value="value" :size="size" @input="changeValue">
      <template v-for="option in defaultBoxSize">
        <a-radio @click="getValue(option.CODE_ID)" class="default-radio-option" :value="option.CODE_ID">{{option.CODE_NAME}}</a-radio>
      </template>
      <a-radio v-if="moreSizeOptions.length > 0 && moreOption.CODE_ID" @click="getValue(moreOption.CODE_ID)" class="more-radio-option" :value="moreOption.CODE_ID">
        <a-popover placement="bottom" overlayClassName="select-type-list">
          <template slot="content">
            <div  style="width: 290px;">
              <a-row>
                <a-col class="select-type-item" :class="{ 'select-type-item-actived':item.CODE_ID === value }"  :span="6" v-for="item in moreSizeOptions" :key="item.CODE_ID"  @click="pickMoreBoxSize(item.CODE_ID)">
                 {{ $dt(item, 'CODE_NAME') }}
                </a-col>
              </a-row>
            </div>
          </template>
          {{ $dt(moreOption, 'CODE_NAME') }} <a-icon style="color:#999999;" type="down" />
        </a-popover>
      </a-radio>
    </a-radio-group>
    <a-popover v-if="!moreOption.CODE_ID" placement="bottom" style="margin-right: 32px" overlayClassName="select-type-list">
      <template slot="content">
        <div  style="width: 290px;">
          <a-row>
            <a-col class="select-type-item" :class="{ 'select-type-item-actived':item.CODE_ID === value }"  :span="6" v-for="item in moreSizeOptions" :key="item.CODE_ID"  @click="pickMoreBoxSize(item.CODE_ID,item.CODE_NAME)">
              {{ $dt(item, 'CODE_NAME') }}
            </a-col>
          </a-row>
        </div>
      </template>
      <span style="font-size: 16px;">{{ $dt(moreOption, 'CODE_NAME') }} </span><a-icon style="color:#999999;" type="down" />
    </a-popover>
    <a-popover placement="top">
      <template slot="content">
        <div v-html="$t('selectBoxSizeHint')" style="width: 380px;word-break: break-all"></div>
      </template>
      <a-icon style="color:#999999;" type="question-circle" />
    </a-popover>
  </div>
</template>

<script>
const defaultBoxSize = [
  {CODE_NAME: '20GP', CODE_ID: 10000008},
  {CODE_NAME: '40HQ', CODE_ID: 10000012},
]

export default {
  name: "selectBoxSize",
  props: {
    value: {type: Number},
    size: {type: String, default: 'large'},
  },
  data() {
    return {
      defaultBoxSize,
      allSizeOption: [],
    }
  },
  computed: {
    moreSizeOptions(){
      return this.allSizeOption.filter(item => !this.defaultBoxSize.find(defaultOption => defaultOption.CODE_ID === item.CODE_ID));
    },
    moreOption(){
      if(!this.value || this.defaultBoxSize.find(item => item.CODE_ID === this.value)){
        return {
          CODE_ID: 0,
          CODE_NAME: this.$t('more', 'zh'),
          CODE_NAME_ENG: this.$t('more', 'en'),
          CODE_NAME_RUS: this.$t('more', 'ru'),
        };
      }else{
        return this.allSizeOption.find(item => item.CODE_ID === this.value);
      }
    },
  },
  methods: {
    getBoxSize() {
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonQueryJson('BM_BASE_CODE', {TYPE_ID: 10000011}, 1, '')],
      }).then(({data}) => {
        this.allSizeOption = data['DATA_LIST'];
      })
    },
    changeValue(val){
      this.$emit('input', val);
      this.$emit('change', val);
    },
    getBoxObj() {
      return this.allSizeOption.find(item => item.CODE_ID === this.value)
    },
    pickMoreBoxSize(key,code) {
      this.$emit('input', key);
      this.$emit('change', key);
    },
    getValue(id) {
      if(this.value === id) {
        this.$emit("input", null)
      }
    }
  },
  created() {
    this.getBoxSize();
  }
}
</script>
<style lang="scss">
.select-type-list{
  .ant-popover-inner-content{
    padding: 12px 10px;
  }
}
</style>
<style lang="scss" scoped>
.select-type-item{
  text-align: center;
  color: #333333;
  font-size: 14px;
  padding: 6px 14px !important;
  margin: 4px 0;
  cursor: pointer;
}
.select-type-item:hover{
  background-color: #EBF5FA;
  border-radius: 4px;
  color: #1F6CBA;
}
.select-type-item-actived{
  background: #EBF5FA;
  border-radius: 4px;
  color: #1F6CBA;
}
.select-box-size{
  display: flex;
  align-items: center;

  .box-size-radio-group.ant-radio-group::v-deep{
    display: flex;

    .ant-radio-wrapper{
      font-size: 16px;
      margin-right: 32px;
    }
    .ant-radio-inner{
      position: relative;
      top: 0;
      left: 0;
      display: block;
      width: 16px;
      height: 16px;
      background-color: #fff;
      border-color: #d9d9d9;
      border-style: solid;
      border-width: 1px;
      transition: all 0.3s;
      border-radius: 0;
    }
    .ant-radio-checked .ant-radio-inner{
      background-color: #1890ff;
    }
    .ant-radio-inner:after{
      position: absolute;
      top: 50%;
      left: 22%;
      display: table;
      width: 5.71428571px;
      height: 9.14285714px;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(0) translate(-50%,-50%);
      opacity: 0;
      transition: all .1s cubic-bezier(.71,-.46,.88,.6),opacity .1s;
      content: " ";
      border-radius: 0;
      background-color:transparent;
    }
    .ant-radio-checked .ant-radio-inner:after {
      position: absolute;
      display: table;
      border: 2px solid #fff;
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(1) translate(-50%,-50%);
      opacity: 1;
      transition: all .2s cubic-bezier(.12,.4,.29,1.46) .1s;
      content: " ";
    }
    .default-radio-option{
      line-height: 32px;
    }
    .more-radio-option{
      line-height: 32px;display: flex;align-items: center;
    }
  }
}
</style>
